<template>
  <!-- 创建/编辑公司机构表单弹窗 -->
  <a-modal
    :title="formTitle || '新增机构'"
    v-model:visible="open"
    @cancel="onClose"
    :width="900"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <!-- 表单内容 -->
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 中文名称 -->
          <a-form-model-item label="中文名称" prop="deptName">
            <a-input v-model:value="form.deptName" placeholder="请输入" class="form-input-rounded" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 公司简称 -->
          <a-form-model-item label="公司简称" prop="companyAbbreviation">
            <a-input
              v-model:value="form.companyAbbreviation"
              placeholder="请输入"
              class="form-input-rounded"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 英文名称 -->
          <a-form-model-item label="英文名称" prop="englishName">
            <a-input v-model:value="form.englishName" placeholder="请输入" class="form-input-rounded" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 公司代码 -->
          <a-form-model-item label="公司代码" prop="code">
            <a-input v-model:value="form.code" placeholder="请输入" class="form-input-rounded" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 联系人 -->
          <a-form-model-item label="联系人" prop="leader">
            <a-input v-model:value="form.leader" placeholder="请输入" class="form-input-rounded" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 电话 -->
          <a-form-model-item label="电话" prop="phone">
            <a-input
              v-model:value="form.phone"
              :disabled="formType === 2"
              placeholder="请输入"
              class="form-input-rounded"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 用户登录名 -->
          <a-form-model-item label="用户登录名" prop="userName">
            <a-input
              v-model:value="form.userName"
              :disabled="formType === 2"
              placeholder="请输入"
              class="form-input-rounded"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 用户密码 -->
          <a-form-model-item label="用户密码" prop="password">
            <a-input v-model:value="form.password" placeholder="请输入" class="form-input-rounded" />
            <!-- <div style="color: #999; font-size: 12px; margin-top: 4px">
              <template v-if="form.id === undefined">
                提示：默认不填写密码是:公司代码admin
              </template>
              <template v-else>
                提示：不填写不修改密码保持原密码，填写了则为新密码
              </template>
            </div> -->
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 经度（隐藏字段，用于提交数据） -->
      <!-- <a-form-model-item label="经度" prop="longitude" v-show="false">
        <a-input
          v-model:value="form.longitude"
          readonly
          placeholder="请选择经度"
          class="form-input-rounded"
        />
      </a-form-model-item> -->
      <!-- 纬度（隐藏字段，用于提交数据） -->
      <!-- <a-form-model-item label="纬度" prop="latitude" v-show="false">
        <a-input
          v-model:value="form.latitude"
          readonly
          placeholder="请选择纬度"
          class="form-input-rounded"
        />
      </a-form-model-item> -->

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 签约时间 -->
          <a-form-model-item label="签约时间" prop="startTime">
            <a-date-picker
              v-model:value="form.startTime"
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择签约时间"
              allow-clear
              @change="handleStartTimeChange"
              class="form-picker-rounded"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 服务截止时间 -->
          <a-form-model-item label="服务截止时间" prop="endTime">
            <a-date-picker
              v-model:value="form.endTime"
              :key="form.startTime || 'endTime-picker'"
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择服务截止时间"
              allow-clear
              :disabled-date="disabledEndDate"
              class="form-picker-rounded"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 地址（通过地图选点） -->
          <a-form-model-item label="地址" prop="address">
            <a-input-group compact>
              <a-input
                v-model:value="form.address"
                readonly
                placeholder="请选择地址"
                style="width: calc(100% - 100px)"
                class="form-input-rounded"
              />
              <a-button class="map-picker-btn" style="width: 100px" @click="openMapPicker">
                <a-icon type="environment" />地图选点
              </a-button>
            </a-input-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 公司员工手册PDF上传 -->
          <a-form-model-item label="公司员工手册" prop="handbookUrl">
            <pdf-upload
              :value="form.handbookUrl"
              @change="handleHandbookUrlChange"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- LOGO上传 -->
      <a-row :gutter="12" class="last-form-row">
        <a-col :span="12">
          <a-form-model-item label="LOGO" prop="logoUrl">
            <file-upload
              :value="form.logoUrl"
              type="image"
              :count="1"
              @change="handleLogoUrlChange"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button class="cancel-btn" @click="cancel"> 取消 </a-button>

          <a-button class="save-btn" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <!-- 地图选点弹窗组件 -->
    <map-picker
      :visible="mapPickerVisible"
      :longitude="form.longitude"
      :latitude="form.latitude"
      :address="form.address"
      @confirm="handleMapPickerConfirm"
      @cancel="closeMapPicker"
    />
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 公司机构创建/编辑表单组件
 * 功能：提供公司机构的新增和编辑功能
 * - 支持基本信息录入（中文名称、公司简称、英文名称、公司代码等）
 * - 支持用户登录名和密码设置
 * - 支持地图选点选择地址
 * - 支持LOGO和员工手册PDF上传
 * - 支持签约时间和服务截止时间设置（服务截止时间必须在签约时间之后）
 */
import { getDept, addDept, updateDept } from '@/api/system/dept'
import MapPicker from './MapPicker'
import PdfUpload from './PdfUpload'
import moment from 'moment'

export default {
  name: 'CreateForm',
  components: {
    MapPicker,
    PdfUpload,
  },
  data() {
    return {
      // 提交按钮加载状态
      submitLoading: false,
      // 表单标题（新增/修改）
      formTitle: '',
      // 地图选点弹窗显示状态
      mapPickerVisible: false,
      // 表单数据
      form: {
        id: undefined, // 机构ID（修改时使用）
        parentId: undefined, // 父级机构ID（新增子机构时使用）
        deptName: undefined, // 中文名称
        companyAbbreviation: undefined, // 公司简称
        englishName: undefined, // 英文名称
        code: undefined, // 公司代码
        orderNum: 0, // 排序号（后端需要，默认0）
        userName: undefined, // 用户登录名
        password: undefined, // 用户密码
        leader: undefined, // 联系人
        phone: undefined, // 电话
        logoUrl: undefined, // LOGO图片URL
        handbookUrl: undefined, // 员工手册PDF文件URL
        address: undefined, // 地址
        longitude: undefined, // 经度
        latitude: undefined, // 纬度
        startTime: undefined, // 签约时间
        endTime: undefined, // 服务截止时间
        status: 1, // 状态（1-启用，0-禁用，默认1）
      },
      // 抽屉显示状态
      open: false,
      // 表单验证规则
      rules: {
        // 中文名称：必填
        deptName: [
          { required: true, message: '中文名称不能为空', trigger: 'blur' },
        ],
        // 公司简称：必填
        companyAbbreviation: [
          { required: true, message: '公司简称不能为空', trigger: 'blur' },
        ],
        // 英文名称：必填
        englishName: [
          { required: true, message: '英文名称不能为空', trigger: 'blur' },
        ],
        // 公司代码：必填
        code: [
          { required: true, message: '公司代码不能为空', trigger: 'blur' },
        ],
        // 联系人：必填
        leader: [
          { required: true, message: '联系人不能为空', trigger: 'blur' },
        ],
        // 用户登录名：必填
        userName: [
          { required: true, message: '用户登录名不能为空', trigger: 'blur' },
        ],
        // 地址：必填
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
        // 签约时间：必填
        startTime: [
          { required: true, message: '签约时间不能为空', trigger: 'blur' },
        ],
        // 服务截止时间：必填，且必须在签约时间之后
        endTime: [
          { required: true, message: '服务截止时间不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              // 使用 created 钩子中定义的验证器
              if (this.validateEndTime) {
                this.validateEndTime(rule, value, callback)
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change'],
          },
        ],
        // 电话：必填，且必须是有效的手机号码格式
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
          },
        ],
      },
      // 表单类型：1-新增，2-修改
      formType: 1,
    }
  },
  created() {
    /**
     * 初始化服务截止时间验证器
     * 验证服务截止时间必须在签约时间之后
     * @param {Object} rule - 验证规则对象
     * @param {String} value - 服务截止时间值
     * @param {Function} callback - 验证回调函数
     */
    this.validateEndTime = (rule, value, callback) => {
      // 如果服务截止时间为空，不进行验证（由 required 规则处理）
      if (!value) {
        callback()
        return
      }
      // 如果签约时间为空，不进行验证（由 required 规则处理）
      if (!this.form.startTime) {
        callback()
        return
      }
      // 比较服务截止时间和签约时间
      const startTime = new Date(this.form.startTime)
      const endTime = new Date(value)
      if (endTime <= startTime) {
        callback(new Error('服务截止时间必须在签约时间之后'))
      } else {
        callback()
      }
    }
  },
  methods: {
    /**
     * 关闭抽屉
     */
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    /**
     * 取消按钮 - 关闭抽屉并重置表单
     */
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    /**
     * 表单重置
     * 清空所有表单字段，恢复为初始状态
     */
    reset() {
      this.form = {
        id: undefined, // 机构ID
        parentId: undefined, // 父级机构ID
        deptName: undefined, // 中文名称
        companyAbbreviation: undefined, // 公司简称
        englishName: undefined, // 英文名称
        code: undefined, // 公司代码
        orderNum: 0, // 排序号
        userName: undefined, // 用户登录名
        password: undefined, // 用户密码
        leader: undefined, // 联系人
        phone: undefined, // 电话
        logoUrl: undefined, // LOGO图片URL
        handbookUrl: undefined, // 员工手册PDF文件URL
        address: undefined, // 地址
        longitude: undefined, // 经度
        latitude: undefined, // 纬度
        startTime: undefined, // 签约时间
        endTime: undefined, // 服务截止时间
        status: 1, // 状态（默认启用）
      }
      // 重置表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    /**
     * 打开地图选点弹窗
     */
    openMapPicker() {
      this.mapPickerVisible = true
    },
    /**
     * 地图选点确认回调
     * @param {Object} data - 包含 longitude, latitude, address 的对象
     */
    handleMapPickerConfirm(data) {
      this.form.longitude = data.longitude
      this.form.latitude = data.latitude
      this.form.address = data.address
      this.closeMapPicker()
    },
    /**
     * 关闭地图选点弹窗
     */
    closeMapPicker() {
      this.mapPickerVisible = false
    },
    /**
     * 处理签约时间变化
     * 当签约时间改变时，如果服务截止时间在签约时间之前或当天，清空服务截止时间
     * @param {String} date - 新的签约时间
     */
    handleStartTimeChange(date) {
      // 如果签约时间改变，且服务截止时间已选择
      if (this.form.endTime && date) {
        const startTime = moment(date, 'YYYY-MM-DD')
        const endTime = moment(this.form.endTime, 'YYYY-MM-DD')
        // 如果服务截止时间在签约时间之前或当天，清空服务截止时间
        if (endTime.isBefore(startTime, 'day') || endTime.isSame(startTime, 'day')) {
          this.form.endTime = undefined
          // 清除服务截止时间的验证错误
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.clearValidate(['endTime'])
            }
          })
        }
      }
      // 强制更新服务截止时间选择器，使其重新计算可选择的日期
      this.$forceUpdate()
    },
    /**
     * 处理LOGO上传回调
     * @param {String} url - 上传后的图片URL
     */
    handleLogoUrlChange(url) {
      this.form.logoUrl = url
    },
    /**
     * 处理公司员工手册PDF上传回调
     * @param {String} url - 上传后的PDF文件URL
     */
    handleHandbookUrlChange(url) {
      this.form.handbookUrl = url
    },
    /**
     * 禁用服务截止时间的日期选择
     * 禁用签约时间当天及之前的日期，确保服务截止时间必须在签约时间之后
     * @param {Object} current - moment对象，当前日期
     * @returns {Boolean} true-禁用该日期，false-不禁用
     */
    disabledEndDate(current) {
      if (!this.form.startTime || !current) {
        return false
      }
      // 确保 current 是 moment 对象
      if (!moment.isMoment(current)) {
        return false
      }
      // 将签约时间转换为 moment 对象进行比较
      const startTime = moment(this.form.startTime, 'YYYY-MM-DD')
      if (!startTime.isValid()) {
        return false
      }
      // 禁用签约时间当天及之前的日期（使用 isBefore 和 isSame 的组合）
      return current.isBefore(startTime, 'day') || current.isSame(startTime, 'day')
    },
    /**
     * 新增按钮操作
     * 打开新增表单抽屉，重置表单并设置表单类型为新增
     * @param {Object} row - 父级机构信息（可选，如果传入则设置为该机构的子机构）
     */
    handleAdd(row) {
      this.reset()
      // 如果传入了父级机构信息，设置父级ID
      if (row !== undefined) {
        this.form.parentId = row.id
      }
      this.open = true
      this.formType = 1
      this.formTitle = '添加机构'
      // 触发事件，通知父组件更新部门树
      $emit(this, 'select-tree')
    },

    /**
     * 修改按钮操作
     * 打开编辑表单抽屉，根据机构ID获取详情并填充表单
     * @param {Object} row - 机构信息对象（必须包含id字段）
     */
    handleUpdate(row) {
      this.reset()
      const deptId = row.id
      // 获取机构详情
      getDept({
        id: deptId,
      })
        .then((response) => {
          this.form = response.data
          this.formType = 2
          this.open = true
          this.formTitle = '修改机构'
        })
        .catch(() => {
          this.$message.error('获取机构信息失败', 3)
        })
      // 触发事件，通知父组件更新部门树
      $emit(this, 'select-tree', row)
    },

    /**
     * 提交表单
     * 根据表单中是否有id判断是新增还是修改，调用对应的接口
     */
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            // 修改机构
            updateDept(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.reset()
                // 触发事件，通知父组件刷新列表
                $emit(this, 'ok')
              })
              .catch(() => {
                this.$message.error('修改失败', 3)
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            // 新增机构
            addDept(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.reset()
                // 触发事件，通知父组件刷新列表
                $emit(this, 'ok')
              })
              .catch(() => {
                this.$message.error('新增失败', 3)
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
  emits: ['select-tree', 'ok', 'close'],
}
</script>

<style scoped>
.create-form-modal :deep(.ant-modal-body) {
  max-height: 75vh;
  overflow-y: auto;
  padding: 24px 24px 240px 24px !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.create-form-modal :deep(.ant-form-item) {
  margin-bottom: 20px;
  margin-top: 0;
}

.last-form-row {
  margin-bottom: 60px !important;
}

.create-form-modal :deep(.ant-form-item-label) {
  padding-bottom: 6px;
  flex: 0 0 150px !important;
}

.create-form-modal :deep(.ant-form-item-label > label) {
  height: 32px;
  line-height: 32px;
}

.create-form-modal :deep(.ant-form-item-control) {
  flex: 1 1 auto;
  line-height: 32px;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 列之间的间距 - 确保左右对称 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
  padding-left: 0 !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
  padding-right: 0 !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
  text-align: right;
  padding-right: 8px !important;
  flex: 0 0 150px !important;
}

.two-column-form :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
  justify-content: flex-end;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 1.5 !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  font-size: 13px !important;
  letter-spacing: -0.2px;
}

.two-column-form :deep(.ant-form-item-control) {
  flex: 1;
  min-width: 0;
}

/* 调整输入框宽度 */
.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-select),
.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-tree-select) {
  width: 100%;
  min-width: 180px;
}

.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.save-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.save-btn:active {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}

/* 地图选点按钮样式 */
.map-picker-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.map-picker-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.map-picker-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.map-picker-btn:active {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

/* 地址输入框组样式 - 去掉输入框右侧圆角和按钮左侧圆角 */
:deep(.ant-input-group-compact .ant-input) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

:deep(.ant-input-group-compact .map-picker-btn) {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

:deep(.ant-input-group-compact .map-picker-btn:hover),
:deep(.ant-input-group-compact .map-picker-btn:focus),
:deep(.ant-input-group-compact .map-picker-btn:active) {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 上传组件容器 - 水平排列，左右对齐 */
.create-form-modal .upload-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 50px;
  padding-bottom: 20px;
  min-height: 120px;
}

/* 单个上传组件样式 */
.create-form-modal .upload-item {
  flex: 0 0 auto;
  margin-bottom: 20px;
  width: calc(50% - 10px);
  padding-bottom: 10px;
}

.create-form-modal .upload-item :deep(.ant-form-item) {
  margin-bottom: 0;
}

.create-form-modal .upload-item :deep(.ant-form-item-label) {
  text-align: left;
  padding-bottom: 8px;
  flex: 0 0 auto !important;
  width: auto !important;
  min-width: auto !important;
  max-width: none !important;
}

.create-form-modal .upload-item :deep(.ant-form-item-label > label) {
  white-space: nowrap;
  text-align: left;
}

.create-form-modal .upload-item :deep(.ant-form-item-control) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 0 0 auto;
}

.create-form-modal .upload-item :deep(.ant-form-item-control-input) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.create-form-modal .upload-item :deep(.ant-form-item-control-input-content) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.create-form-modal .upload-item :deep(.clearfix) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.create-form-modal .upload-item :deep(.ant-upload) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
